import { render, staticRenderFns } from "./WcIconAlert.vue?vue&type=template&id=20ab83a1&lang=pug&"
import script from "./WcIconAlert.vue?vue&type=script&lang=js&"
export * from "./WcIconAlert.vue?vue&type=script&lang=js&"
import style0 from "./WcIconAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports